import { BorderRadiusType, FullBorderRadiusType } from 'common/types/styleTypes'
import {
  borderRadiusCss,
  mobileBorderRadiusCss,
  mobilePaddingsCss,
  paddingsCss,
} from 'common/utils/styleUtilsNew'
import { css, styled } from 'styled-components'
import { FormInterface } from '../form.schema'

export interface FormSuccessOptInScreenOverlayUiProps
  extends Pick<
    FormInterface,
    | 'padding'
    | 'mobilePadding'
    | 'backgroundColor'
    | 'mobileBackgroundColor'
    | 'border'
    | 'mobileBorder'
  > {
  borderRadius: BorderRadiusType | FullBorderRadiusType | undefined
  mobileBorderRadius: BorderRadiusType | FullBorderRadiusType | undefined
}

export const FormSuccessOptInScreenOverlayUi = styled.div<FormSuccessOptInScreenOverlayUiProps>`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: absolute;
  ${p => p.border?.width && `top: -${p.border.width}px;`}
  ${p => p.border?.width && `left: -${p.border.width}px;`}
  ${p => p.border?.width && `right: -${p.border.width}px;`}
  ${p => p.border?.width && `bottom: -${p.border.width}px;`}
  z-index: 20;

  backdrop-filter: blur(10px);
  ${borderRadiusCss}
  ${paddingsCss}
  
  ${p => p.theme.phone} {
    ${p => p.mobileBorder?.width && `top: -${p.mobileBorder.width}px;`}
    ${p => p.mobileBorder?.width && `left: -${p.mobileBorder.width}px;`}
    ${p => p.mobileBorder?.width && `right: -${p.mobileBorder.width}px;`}
    ${p => p.mobileBorder?.width && `bottom: -${p.mobileBorder.width}px;`}
    ${mobileBorderRadiusCss}
    ${mobilePaddingsCss}
  }
  ${p =>
    p.theme.isEditorMobileMode &&
    css`
      ${p.mobileBorder?.width && `top: -${p.mobileBorder.width}px;`}
      ${p.mobileBorder?.width && `left: -${p.mobileBorder.width}px;`}
      ${p.mobileBorder?.width && `right: -${p.mobileBorder.width}px;`}
      ${p.mobileBorder?.width && `bottom: -${p.mobileBorder.width}px;`}
      ${mobileBorderRadiusCss}
      ${mobilePaddingsCss}
  `}
`
